import Vue from "vue";
import base from "../baseCore";

export default Object.assign(
    {
        apiUrl: "/tracker",

        async get() {
          return  Vue.http.get(this.url(`/`));
        },

        async getLocalTree({ id }) {
          return  Vue.http.get(this.url(`/${id}/filtro/open/local`));
        },

        async list({name = '' }) {
          return  Vue.http.get(this.url(`?name=${name}`));
        },

        async save({
          type,
          trackerIdentification,
          trackerTokenOrSecret,
          name,
          isDefault,
          localId,
          ssidFilter,
          allSsidSelected
        }) {
          return type === "FACEBOOK_PIXEL" ?
          Vue.http.post(this.url(`/`), {
            type,
            pixelId: trackerIdentification,
            accessToken: trackerTokenOrSecret,
            name,
            isDefault,
            localId,
            ssidFilter,
            allSsidSelected
          }) :
          Vue.http.post(this.url(`/`), {
            type,
            measurementId: trackerIdentification,
            apiSecret: trackerTokenOrSecret,
            name,
            isDefault,
            localId,
            ssidFilter,
            allSsidSelected
          })
        },

        async edit({
          id,
          type,
          trackerIdentification,
          trackerTokenOrSecret,
          name,
          isDefault,
          localId,
          ssidFilter,
          allSsidSelected
        }) {
          return type === "FACEBOOK_PIXEL" ?
          Vue.http.put(this.url(`/${id}/`), {
            type,
            pixelId: trackerIdentification,
            accessToken: trackerTokenOrSecret,
            name,
            isDefault,
            localId,
            ssidFilter,
            allSsidSelected
          }) :
          Vue.http.put(this.url(`/${id}/`), {
            type,
            measurementId: trackerIdentification,
            apiSecret: trackerTokenOrSecret,
            name,
            isDefault,
            localId,
            ssidFilter,
            allSsidSelected
          })
        },

        async clear() {
          return Vue.http.delete(this.url(`/`));
        },

        async delete({ id }) {
          return Vue.http.delete(this.url(`/${id}/`));
        },
    },
    base
);
